import { Dimmer, Loader, Segment } from "semantic-ui-react"

const BifrostLoader = ({
	backgroundColor = "default",
	inverted = false,
	height = "100%",
	minHeight = false,
	border = "0px",
	size,
	text,
	isLoading,
	children
}) => {
	return (
		<>
			{isLoading ? (
				<div style={{ minHeight: minHeight, height: height }}>
					<Segment
						style={{
							boxShadow: "none",
							border: border,
							height: minHeight ? minHeight : height
						}}
					>
						<Dimmer className={"bg-" + backgroundColor} inverted={!!inverted} active>
							<Loader size={size && size} inverted>
								{text}
							</Loader>
						</Dimmer>
					</Segment>
				</div>
			) : (
				<>{children}</>
			)}
		</>
	)
}

export default BifrostLoader
